{
	"title": "Library",
	"subtitle": "Every material you've uploaded",
	"add": "Add",
	"segments": {
		"all": "All {count}",
		"notInCourse": "Without a course {count}",
		"noFolder": "No folder {count}"
	},
	"filters": {
		"search": "Search materials",
		"type": "Type",
		"anyType": "Any type",
		"folder": "Folder",
		"reset": "Reset filters"
	},
	"folders": {
		"title": "Folders",
		"all": "All",
		"noFolder": "No folder",
		"create": "＋ New folder",
		"createTitle": "New folder",
		"nameLabel": "Name",
		"namePlaceholder": "For example, Lectures",
		"colorLabel": "Color",
		"submit": "Create",
		"cancel": "Cancel",
		"created": "Folder created",
		"createError": "Could not create the folder",
		"rename": "Rename",
		"renamed": "Folder renamed",
		"renameError": "Could not rename the folder",
		"delete": "Delete folder",
		"deleteConfirmTitle": "Delete the folder?",
		"deleteConfirmDescription": "The folder «{name}» will be removed. Its materials stay in the library.",
		"deleted": "Folder deleted",
		"deleteError": "Could not delete the folder",
		"itemsCount": "{count, plural, one {# material} other {# materials}}",
		"empty": "No folders yet",
		"pick": "Folder",
		"open": "Open folder",
		"actions": "Folder actions",
		"openBanner": "Open folder “{name}”",
		"pageDescription": "Open a folder to generate a note, flashcards or a test from all of its materials",
		"emptyTitle": "No folders yet",
		"materialsCount": "{count, plural, one {# material} other {# materials}}",
		"emptyHint": "Create a folder to group materials and generate a note, flashcards or a test from all of them at once",
		"searchPlaceholder": "Search folders",
		"sort": {
			"label": "Sorting",
			"default": "Library order",
			"name": "By name",
			"materials": "By material count"
		},
		"loadError": "Couldn't load your folders",
		"emptyFiltered": "No folder matches your search"
	},
	"card": {
		"inCourses": "{count, plural, one {in # course} other {in # courses}}",
		"notInCourse": "Without a course",
		"noFolder": "No folder",
		"open": "Open"
	},
	"selection": {
		"enter": "Select",
		"exit": "Cancel",
		"count": "{count} selected",
		"toCourse": "To course",
		"toFolder": "To folder",
		"delete": "Delete",
		"selectAll": "Select all",
		"pickCourse": "Pick a course",
		"pickFolder": "Pick a folder",
		"newCourse": "＋ New course",
		"removeFromFolder": "Remove from folder",
		"addedToCourse": "{count, plural, one {# material} other {# materials}} → {course}",
		"openCourse": "Open course",
		"addToCourseError": "Could not add to the course",
		"movedToFolder": "{count, plural, one {# material moved} other {# materials moved}}",
		"moveToFolderError": "Could not move to the folder",
		"hintTouch": "Long-press a card to select several",
		"hintDesktop": "Shift — a range, Cmd/Ctrl — one by one"
	},
	"empty": {
		"library": {
			"title": "The library is empty",
			"description": "Upload the first material — a lecture, a textbook chapter or a recording.",
			"cta": "Upload material"
		},
		"filter": {
			"title": "Nothing matches the filter",
			"description": "Change the query, the type or the folder.",
			"cta": "Reset filters"
		},
		"notInCourse": {
			"title": "Everything is in a course",
			"description": "No unattached materials left."
		},
		"folder": {
			"title": "The folder is empty",
			"description": "Move materials here or upload new ones.",
			"upload": "Upload",
			"pickExisting": "Pick existing"
		}
	},
	"errors": {
		"loadFailed": "Could not load the library",
		"retry": "Retry"
	},
	"picker": {
		"title": "Pick materials",
		"description": "Search across the library, filter by folder.",
		"submit": "Add",
		"cancel": "Cancel",
		"selected": "{count} selected",
		"empty": "Nothing to pick"
	},
	"addTo": {
		"trigger": "Add to folder",
		"title": "Save to folder",
		"loading": "Loading folders…",
		"empty": "You don't have any folders yet. Create your first one and this item will be added to it.",
		"errorTitle": "Failed to load folders",
		"retry": "Retry",
		"createSection": "Create folder",
		"createPlaceholder": "Folder name",
		"createCta": "Create",
		"creating": "Creating…",
		"added": "Added to \"{name}\"",
		"removed": "Removed from \"{name}\"",
		"toggleError": "Failed to update folder",
		"createError": "Failed to create folder",
		"itemChecked": "Item is in folder \"{name}\"",
		"itemUnchecked": "Item is not in folder \"{name}\""
	},
	"detail": {
		"collectionLabel": "Folder",
		"back": "To folders",
		"sectionMaterials": "Materials",
		"sectionMaterialsHint": "Materials in the folder and artifacts generated from them",
		"sectionSetWide": "Folder-wide",
		"sectionSetWideHint": "Artifacts generated from the entire folder",
		"sectionStandalone": "Standalone items",
		"sectionStandaloneHint": "Added to the folder directly",
		"groupArtifactsToggle": "{count, plural, one {# artifact} other {# artifacts}}",
		"emptyTitle": "Folder is empty",
		"emptyDescription": "Add materials or artifacts to gather them in one place.",
		"openMaterial": "Open material",
		"generatePlan": "Generate study plan",
		"generatePlanStarted": "Building a study plan from the folder…",
		"generatePlanError": "Failed to create the study plan",
		"notFound": "Folder not found",
		"loadFailed": "Couldn’t load folder",
		"syncPending": "Waiting for sync",
		"retry": "Retry"
	},
	"generate": {
		"sectionTitle": "Generate from the whole folder",
		"sectionHint": "AI will build a single artifact based on all materials in the folder",
		"notes": "Folder notes",
		"flashcards": "Folder flashcards",
		"quiz": "Folder quiz",
		"regenerate": "Regenerate",
		"open": "Open",
		"generating": "Generating…",
		"started": "Generation started — the artifact will appear here",
		"failed": "Generation failed. Please try again",
		"noMaterials": "Add materials to the folder to generate artifacts",
		"staleBadge": "Folder changed",
		"staleHint": "The folder changed after generation — refresh the artifact",
		"confirmTitle": "Generate from the whole folder",
		"confirmDescription": "All {count, plural, one {# material} other {# materials}} in the folder will be used.",
		"confirmQuota": "This will use about {units, plural, one {# unit} other {# units}} of your AI quota.",
		"confirmCancel": "Cancel",
		"confirmStart": "Generate",
		"studyPlan": "Study plan",
		"studyPlanHint": "A step-by-step study plan from the folder's materials",
		"planConfirmTitle": "Create a study plan?",
		"planConfirmDescription": "AI will build a step-by-step study plan from {count, plural, one {# material} other {# materials}} in this folder. This is a large generation — it can take up to a minute.",
		"planConfirmQuota": "This uses 1 AI quota unit.",
		"planConfirmCancel": "Cancel",
		"planConfirmStart": "Create plan"
	},
	"chat": {
		"askAi": "Ask AI about the folder",
		"voice": "Voice walkthrough of the folder",
		"contextBadge": "Context: folder \"{name}\"",
		"pickCollection": "By folders",
		"pickMaterials": "By materials",
		"pickPlaceholder": "No folder",
		"pickSearch": "Search folder…",
		"pickNone": "No folder"
	},
	"artifact": {
		"type": {
			"material": "Material",
			"test": "Test",
			"flashcard_set": "Flashcards",
			"note": "Note",
			"audio_recap": "Audio recap",
			"visual_analysis": "Visual explanation",
			"essay": "Essay"
		},
		"open": "Open",
		"publish": {
			"make": "Make public",
			"public": "Public",
			"private": "Private",
			"toggleAria": "Artifact publication",
			"madePublic": "Artifact published",
			"madePrivate": "Publication removed",
			"error": "Couldn't change publication",
			"hint": "Public artifacts appear in the folder's public listing"
		}
	},
	"testsFilter": {
		"label": "Folder",
		"all": "All folders",
		"placeholder": "Filter by folder",
		"empty": "No folders",
		"search": "Search folder…",
		"clear": "Clear filter"
	},
	"addMenu": {
		"trigger": "Add",
		"menuTitle": "Add to folder",
		"uploadNew": "Upload a new material",
		"pickExisting": "Pick existing"
	},
	"upload": {
		"successToCollection": "Added to folder",
		"membershipBadge": "{count, plural, one {in # folder} other {in # folders}}",
		"membershipOne": "In folder"
	},
	"artifactPicker": {
		"title": "Pick existing",
		"description": "Add materials, standalone artifacts, and items created from AI chat. Artifacts attached to a regular material are hidden — add the material itself and they come with it.",
		"tabs": {
			"material": "Materials",
			"flashcard_set": "Flashcards",
			"test": "Tests",
			"note": "Notes",
			"audio_recap": "Audio recaps",
			"visual_analysis": "Visuals",
			"essay": "Essays"
		},
		"loading": "Loading…",
		"errorTitle": "Failed to load",
		"retry": "Retry",
		"empty": "No standalone items of this type",
		"emptyHint": "Here: unbound artifacts and ones from chat. Everything else — via the Materials tab.",
		"goToMaterials": "Go to materials",
		"standaloneCount": "{count, plural, one {# item without a regular material} other {# items without a regular material}}",
		"fromChat": "from chat “{name}”",
		"fromChatFallback": "chat",
		"noMatches": "Nothing found",
		"search": "Search…",
		"selectedCount": "{count, plural, one {# item selected} other {# items selected}}",
		"cancel": "Cancel",
		"add": "Add",
		"addCount": "Add ({count})",
		"added": "{count, plural, one {# item added} other {# items added}}",
		"addedWithChat": "Added. Chat artifacts were included via the dialogue material.",
		"addError": "Failed to add to folder",
		"limitReached": "You can add up to {limit} items at a time"
	},
	"share": {
		"trigger": "Share",
		"dialogTitle": "Share folder",
		"dialogDescription": "Open access to the folder via a link.",
		"publicExplain": "The folder and all of its materials become accessible to anyone with the link — read-only. Artifacts stay private.",
		"makePublic": "Make public",
		"isPublicTitle": "Folder is accessible via link",
		"isPublicHint": "Anyone with the link can see the folder and its materials.",
		"linkLabel": "Folder link",
		"copy": "Copy link",
		"copied": "Link copied",
		"revoke": "Revoke access",
		"revoked": "Access revoked",
		"made": "Folder published",
		"error": "Couldn't change access",
		"done": "Done"
	},
	"dock": {
		"addToCollection": "Add to folder",
		"dropTitle": "Drop into a folder",
		"added": "Added to folder",
		"newCollection": "New folder",
		"pick": "Pick a folder",
		"pickTitle": "Add to folder",
		"pickSearch": "Search folders…",
		"pickEmpty": "No folders yet",
		"more": "{count} more",
		"dropHere": "Drop here",
		"emptyHint": "Drop here to create your first folder",
		"createError": "Failed to create folder",
		"addError": "Failed to add to folder"
	},
	"addArtifact": {
		"title": "What should go into the folder?",
		"wholeMaterial": "Add the whole material \"{material}\"",
		"wholeMaterialHint": "Together with all its notes, tests and flashcards",
		"copy": "Create a standalone copy: {type}",
		"copyHint": "Only this {type}, separate from the material",
		"materialAdded": "Material added to folder",
		"copied": "Copied to folder",
		"copying": "Copying…",
		"copyReady": "Copy added to folder",
		"copyFailed": "Failed to create the copy",
		"error": "Failed to add to folder"
	},
	"intro": {
		"title": "The library holds sources",
		"body": "Everything you uploaded lives here: files, links, texts. Notes, tests and cards are derived from them and have sections of their own.",
		"bullets": [
			"One source can sit in several folders and courses",
			"A filter shows what has not made it into any course",
			"A whole folder can be sent into a course"
		]
	}
}
